import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  number: 'BONUS 1',
  emoji: '🧠',
  title: 'Cómo criar a tu hijo estando separado/a',
  desc: 'Para darle estabilidad emocional incluso en medio del conflicto'
}, {
  number: 'BONUS 2',
  emoji: '💬',
  title: 'Cómo hablar con tu hijo sobre la separación',
  desc: 'Qué decir, qué evitar y cómo acompañarlo'
}, {
  number: 'BONUS 3',
  emoji: '⚖️',
  title: 'Cómo poner límites sin generar más conflicto',
  desc: 'Para decir que no sin escalar discusiones'
}];
export function BonusSection() {
  return <section className="bg-[#17304F] py-20 px-6 border-t border-slate-800/50" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <div className="text-center mb-12" data-id="element-25">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-red-900/30 text-red-400 px-4 py-2 rounded-full font-bold text-sm mb-6 border border-red-500/30" data-id="element-26">
            <Gift size={18} data-id="element-27" />
            <span data-id="element-28">OFERTA ESPECIAL</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-29">
            Hoy no solo recibís la guía principal…
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-slate-300" data-id="element-30">
            También te llevás{' '}
            <span className="text-green-400 font-bold" data-id="element-31">GRATIS</span>:
          </motion.p>
        </div>

        {/* Bonus image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="flex justify-center mb-12" data-id="element-32">
          <img src="https://cdn.magicpatterns.com/uploads/cRSaYLDvnW7FFjgre61icw/Gemini_Generated_Image_7mt76r7mt76r7mt7.png" alt="Bonus: 3 guías adicionales gratis" className="w-full max-w-xl rounded-2xl shadow-2xl shadow-black/30" data-id="element-33" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-34">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3 + index * 0.1
        }} className="bg-slate-800 rounded-2xl p-8 border border-slate-700 relative overflow-hidden" data-id="element-35">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-36">
                GRATIS
              </div>
              <div className="text-xs font-bold text-red-400 uppercase tracking-widest mb-3" data-id="element-37">
                {bonus.number}
              </div>
              <div className="text-3xl mb-3" data-id="element-38">{bonus.emoji}</div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-39">
                {bonus.title}
              </h3>
              <p className="text-slate-400 text-sm" data-id="element-40">{bonus.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}